<ng-template #content let-c="close" id="modal">


  <div class="modal-header">
    <h4 *ngIf="isEdit" class="modal-title">Edit User</h4>
    <h4 *ngIf="!isEdit" class="modal-title">New User</h4>

    <button type="button" class="btn-close" aria-label="Close" (click)="onDismiss()">
    </button>
  </div>

  <div class="modal-body">

    <div class="container-fluid">
      <form [formGroup]="accountForm" (ngSubmit)="onSubmit()">
        <div *ngIf="generalErrors.length > 0" class="row">
          <ccc-error-showing errorTitle="Please review the errors below" [errors]="generalErrors"
            (closeWarning)="generalErrors=[]" class="w-100">

          </ccc-error-showing>
        </div>
        <div class="row modal-new">
          <div class="col-md-4">
            <ccc-error-container [errors]="accountForm.controls.externalRef.touched &&
                                           accountForm.controls.externalRef.hasError('required')?['Id is required']: []">
              <span class="modal-form-text">District Assigned ID *</span>
              <input type="text"
                     #externalRefInput
                     [attr.disabled]="isLoading ? true : null"
                     placeholder="###-#####-##"
                     class="form-control form-control-sm user-id"
                     formControlName="externalRef">
            </ccc-error-container>
          </div>
        </div>


        <div class="row modal-new">
          <div class="col-md-4">
            <ccc-error-container
              [errors]="accountForm.controls.firstName.touched &&
                                           accountForm.controls.firstName.hasError('required')?['First Name is required']: []">
              <span class="modal-form-text">First Name *</span>
              <input type="text"
                     [attr.disabled]="isLoading ? true : null"
                     class="form-control form-control-sm"
                     formControlName="firstName">
            </ccc-error-container>
          </div>

          <div class="col-md-4">
            <ccc-error-container
              [errors]="accountForm.controls.lastName.touched &&
                                           accountForm.controls.lastName.hasError('required')?['Last Name is required']: []">
              <span class="modal-form-text">Last Name *</span>
              <input type="text"
                     [attr.disabled]="isLoading ? true : null"
                     class="form-control form-control-sm"
                     formControlName="lastName">
            </ccc-error-container>
          </div>

          <div class="col-md-4">
            <ccc-error-container [errors]="accountForm.controls.email.touched && (accountForm.controls.email.hasError('required')|| accountForm.controls.email.hasError('invalidEmailAddress'))?[
              'Email must be a valid email pattern ']: []   && errors['email']">
              <span class="modal-form-text">Email *</span>
              <input type="email"
                     class="form-control form-control-sm"
                     formControlName="email">
            </ccc-error-container>
          </div>

        </div>

        <div class="row modal-new">
          <div class="col-md-4">
            <span class="modal-form-text">Title *</span>

            <span class="modal-form-text mt-1"
                  *ngIf="!accountForm.get('title').enabled">{{accountToEdit.title}}</span>

            <select class="form-control form-control-sm"
                    [attr.disabled]="isLoading ? true : null"
                    formControlName="title"
                    *ngIf="accountForm.get('title').enabled">
              <option disabled selected value="null">
                {{titles?.length === 0 ? 'No recorded titles' : 'Please select'}}
              </option>

              <option *ngFor="let title of titles"
                      [selected]="title === accountForm.controls.title.value"
                      [value]="title">
                {{title}}
              </option>
            </select>

          </div>
          <div class="col-md-4">
            <span class="modal-form-text">
              District/School Title
            </span>
            <input type="text"
                   [attr.disabled]="isLoading ? true : null"
                   placeholder="Descriptive Title (Optional)"
                   class="form-control form-control-sm"
                   minlength="3"
                   maxlength="50"
                   (input)="checkDistrictSchoolTitle()"
                   formControlName="districtSchoolTitle">
            <div class="invalid-feedback d-block"
                 *ngIf="accountErrors.districtSchoolTitle.length > 0">
              <ul>
                <li *ngFor="let error of accountErrors.districtSchoolTitle">
                  {{ error }}
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-4">
            <span class="modal-form-text">
              Is this account in a leadership role at the school or district?
            </span>
            <div class="d-flex align-items-center">
              <input type="radio"
                     id="leadershipTrue"
                     class="me-2"
                     [value]="true"
                     [attr.disabled]="isLoading ? true : null"
                     formControlName="leadershipFlag">
              <label for="leadershipTrue" class="body-14 mb-0">Yes</label>
              <input type="radio"
                     id="leadershipFalse"
                     class="mx-2"
                     [value]="false"
                     [attr.disabled]="isLoading ? true : null"
                     formControlName="leadershipFlag">
              <label for="leadershipFalse" class="body-14 mb-0">No</label>
            </div>
          </div>
        </div>

        <div formArrayName="affiliations" *ngFor="let item of accountForm.get('affiliations')?.controls; let i = index;">

          <div [formGroupName]="i" class="row affiliation modal-new">

            <div class="col-md-4">
              <ccc-error-container [errors]="item.controls.affiliation.touched && item.controls.affiliation.hasError('required')?
                                             [' Please select affiliation'] : []">
                <span class="modal-form-text">Affiliation *</span>
                <select class=" form-control form-control-sm  affiliation" formControlName="affiliation"
                  (change)="onAffiliationSelected(i)">
                  <option disabled selected value="">

                    {{schoolsToShow[i]?.length ===0? '  No affiliations to select' : 'Please select'}}

                  </option>

                  <option *ngFor="let aff of schoolsToShow[i]"
                          [value]="aff.id"
                          [disabled]="isAffiliationSelected(aff)"
                          [selected]="aff.id === item.controls.affiliation.value">
                    <div [innerHTML]="aff.name"></div>
                  </option>
                </select>
                <div *ngIf="!schoolsToShow[i]" class="loader">
                  <i class="fas fa-spinner  fa-spin fa-lg  icons"> </i>
                </div>
              </ccc-error-container>
            </div>

            <div class="col-md-4">
              <ccc-error-container [errors]="item.controls.role.touched && item.controls.role.hasError('required')?
              [' Please select role'] : []">
                <span class="modal-form-text">Role *</span>
                <select class=" form-control form-control-sm  affiliation" formControlName="role">
                  <option disabled selected value="">
                    {{rolesToShow[i]?.length===0? '  No roles to select' : 'Please select'}}


                  </option>
                  <option [selected]="role.id === item.controls.role.value" *ngFor="let role of rolesToShow[i]"
                    [value]="role.id">{{role.name}} </option>
                </select>

                <div *ngIf="loadingRoles[i]===true" class="loader">
                  <i class="fas fa-spinner  fa-spin fa-lg  icons"> </i>
                </div>
              </ccc-error-container>
            </div>

            <div class="col-md-4 remove-affiliation-col">
              <div class="remove-affiliation">
                <span *ngIf="affiliations.length > 1"
                      (click)="removeAffiliation(i)"
                      title="Remove this affiliation">
                  <i class="fas fa-times icons times"> </i>
                </span>

                <span *ngIf="selectedAffiliation[i] && hasChildren[i]" title="Include locations below organizations">
                  <input type="checkbox" class="pointer ms-2" formControlName="includeChildren"
                    (change)="onIncludeChildren()" />
                  Include locations below
                </span>
              </div>
            </div>
          </div>

        </div>
        <div *ngIf="showAddAnotherAffiliation()" class="add-another" (click)="addAnotherAffiliation()">
          <i class="fas fa-plus icons plus"> </i>
          &nbsp; Add another affiliation
        </div>
      </form>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button"
            class="btn btn-cancel"
            (click)="onDismiss()">Cancel</button>
    <div *ngIf="isSending">
      <i class="fas fa-spinner fa-spin fa-lg icons loading-icon me-2"> </i>
    </div>
    <button type="submit" [disabled]="disabledButton()"
      class="btn-primary btn-save" (click)="onSubmit()">Save</button>
  </div>
</ng-template>



<ccc-confirm-modal #modalSave (confirmAction)="onCloseWithoutSaving($event)"></ccc-confirm-modal>
